export default __webpack_public_path__ + "static/media/field-qa.7b41a386.png";